<template>
  <div>
    <app-section-wrap class='_pts'>
      <div column="12">
        <form @submit.prevent="search" class="against-grey-bg">
          <h2 class="_mbm">Invoice Search Context:</h2>

          <div grid>
            <div column>
              <div class="form-group">
                <label for="invoiceNumber">Invoice Number:</label>
                <input
                  type="text"
                  id="invoiceNumber"
                  name="invoiceNumber"
                  value=""
                  v-model="invoiceNumber"
                >
              </div>
            </div>
          </div>

          <div class="_text-center">
            <async-button
              type="submit"
              class="_mtxs --sm"
              :executing="submitting"
            >
              <template #buttonContent>
                <span>Search</span>
              </template>
            </async-button>
          </div>
        </form>
      </div>
    </app-section-wrap>

    <collapsible-section :collapsible="false" :collapsed="false">
      <template #headerText>
        <p class='color-leaf'>Results</p>
      </template>
      <template #headerActions v-if="searchResults">
        <column-picker :headers="searchHeaders" @updateHeaders="updateHeaders"/>
      </template>
      <template #collapsibleSection>
        <async-loader v-if="!loaded"/>
        <no-results-message v-else-if="loaded && !searchResults"/>
        <div container v-else>
          <advanced-table
            class="_p0"
            title="Member Results:"
            id="member-results"
            :headers="searchHeaders"
            :items="searchResults"
          >
            <template #items="{ item, visibleHeaders, getCellValue }" >
              <tr>
                <td v-for='(header, index) in visibleHeaders' v-if="!header.alwaysVisible" :key="index">{{getCellValue(item, header)}}</td>
                <td>
                  <router-link :to="{name: 'invoice-details', params: { invoiceNumber: item.invoiceNumber }}">View Details</router-link>
                </td>
              </tr>
            </template>
          </advanced-table>
        </div>
      </template>
    </collapsible-section>
  </div>
</template>

<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AdvancedTable from '@organisms/AdvancedTable.vue'
  import AsyncButton from '@molecules/AsyncButton.vue'
  import AsyncLoader from '@molecules/AsyncLoader.vue'
  import RequestHelper from '@mixins/RequestHelper'
  import SearchHelper from '@mixins/SearchHelper'
  import SearchApi from '@api/SearchApi'
  import ColumnPicker from '@molecules/ColumnPicker'
  import CollapsibleSection from '../../components/sections/CollapsibleSection'

  export default {
    mixins: [RequestHelper, SearchHelper],
    components: {
      AppSectionWrap,
      AdvancedTable,
      AsyncButton,
      AsyncLoader,
      ColumnPicker,
      CollapsibleSection
    },
    data() {
      return {
        invoiceNumber: '',
        searchHeaders: [
          { text: 'Invoice Number', align: 'left', value: 'invoiceNumber' },
          { text: 'Status', value: 'paymentStatus' },
          { text: 'Balance', value: 'openAmount' },
          { text: 'Invoice Type', value: 'invoiceType' },
          { text: 'Group', value: (item) => `${item.groupName} - ${item.groupId}`, visible: false }, // todo - group name does not come back from the API?
          { text: 'Subgroup', value: (item) => `${item.subGroupName} - ${item.subGroupId}`, visible: false },
          { text: 'Action', value: '', alwaysVisible: true }
        ],
        invoices: [],
        whiteListedQueryParams: [
          'invoiceNumber'
        ]
      }
    },
    methods: {
      search() {
        let groupSelected = this.$store.getters['groupSelector/searchSelection'];
        const query = {
          invoiceNumber: this.invoiceNumber,
          invoiceDate: this.invoiceDate,
          parentGroupCk: groupSelected.parentGroupCk,
          groupCk: groupSelected.groupCk,
          subGroupCk: groupSelected.subGroupCk,
          status: 'ALL'
        }

        this.bindVueDataToRequestResponse({
          vueDatum: 'invoices',
          requestMethod: new SearchApi({ simulateExample: 'Search invoices for Internal - ALL' }).searchInvoices,
          query: query
        })
      },
      updateHeaders(headers) {
        this.searchHeaders = headers
      }
    },
    computed: {
      searchResults() {
        if (this.invoices.status == 'NoRecordFound' || this.invoices.length == 0) {
          return []
        }

        return this.invoices
      }
    }
  }
</script>
